import { render, staticRenderFns } from "./EditPromotionBaseSettings.vue?vue&type=template&id=b907e044&"
import script from "./EditPromotionBaseSettings.vue?vue&type=script&lang=js&"
export * from "./EditPromotionBaseSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports